<div
  class="image-container container"
  style="background-image: url('/assets/images/lifestyle/concept.jpg')"
>
  <h3
    class="title"
  >
    Living by nature
  </h3>
</div>

<div
  class="container video-container"
>
  <p
    class="downtown-description"
    [innerHTML]="'pages.downtown_life.our_view.paragraph' | translate"
  >
  </p>
  <!-- <div
    class="video"
    [innerHtml]="videoInnerHTML"
    appGtagEvent
    eventCategory="video"
    eventAction="click"
    [eventLabel]="'teaser1'"
  >
  </div> -->
</div>

<div
  fxLayout="row"
  fxLayoutAlign="center center"
  class="images container"
>
</div>



// WEBPACK FOOTER //
// ./src/app/downtown-life/our-view.component.html